


import React from 'react';
import { TextField, Grid, InputAdornment, IconButton } from '@material-ui/core';

import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';

const Field = ({ name, handleChange, label, half, autoFocus, type, handleShowPassword, placeholder,component,value }) => (
  <Grid item xs={12} sm={half ? 6 : 12}>
    <TextField
      component={component}
      name={name}
      onChange={handleChange}
      placeholder={placeholder}
      variant="outlined"
      required
      value ={value}
      fullWidth
      label={label}
      autoFocus={autoFocus}
      type={type}
      InputProps={name === 'password' ? {
        endAdornment: (
          <InputAdornment position="end">
            <IconButton onClick={handleShowPassword}>
              {type === 'password' ? <Visibility /> : <VisibilityOff />}
            </IconButton>
          </InputAdornment>
        ),
      } : null}
    />
  </Grid>
);

export default Field
